"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneVerificationSessionSchemaProperties = exports.PhoneVerificationSessionSchema = exports.PhoneVerificationStatus = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.PhoneVerificationStatus = zod_1.z.enum(["pending", "verified"]);
exports.PhoneVerificationSessionSchema = base_schema_1.BaseSchema.extend({
    sessionId: zod_1.z.string(),
    code: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    accountId: zod_1.z.string(),
    status: exports.PhoneVerificationStatus,
    expiresAt: zod_1.z.date(),
    verifiedAt: zod_1.z.date().optional(),
});
exports.PhoneVerificationSessionSchemaProperties = {
    collectionName: "phoneVerificationSessions",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=phone-verification-session-schema.js.map